import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@scramble/ui';
import { useRoundStatus } from '@/hooks/shared/useRoundStatus';
import { MiniFaqs, MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import s from './index.module.scss';

const TABS = t => ({
  0: t('investing:faq.general'),
  2: t('investing:faq.allocation'),
  3: t('investing:faq.review_and_ready'),
  4: t('investing:faq.round_processing'),
  5: t('investing:faq.result'),
});

export const InvestingFaq = ({ step }) => {
  const [activeTab, setActiveTab] = React.useState((step === 1 || step === -1) ? 0 : step);
  const { t } = useTranslation();
  const { status } = useRoundStatus();

  const TABS_T = TABS(t);

  useEffect(() => {
    setActiveTab(step === 1 || step === -1 ? 0 : step);
  }, [step]);

  const params = {
    is_active: status?.is_active,
    has_previously_invested: status?.has_previously_invested,
    step: activeTab,
  };

  return (
    <MiniFaqs
      source={MINIFAQ_SOURCES.investing}
      params={params}
      disabled={!status}
    >
      <div className={s.outer}>
        <div className={s.tabs}>
          {Object.keys(TABS_T).map(key => (
            <Chip
              selected={activeTab === Number(key)}
              size="medium"
              key={key}
              className={s.tab}
              onClick={() => setActiveTab(Number(key))}
            >
              {TABS_T[key]}
            </Chip>
          ))}
        </div>
      </div>
    </MiniFaqs>
  );
};
